import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ToastService } from 'govbr-lib';
import { finalize } from 'rxjs/operators';
import { ClienteSiga } from 'src/app/models/ClienteSiga';
import { EsqueciMinhaSenha } from 'src/app/models/Interface/EsqueciSenha';
import { SigaService } from 'src/app/services/siga.service';

@Component({
  selector: 'gov-esqueci-minha-senha-modal',
  templateUrl: './esqueci-minha-senha-modal.component.html',
  styleUrls: ['./esqueci-minha-senha-modal.component.scss']
})
export class EsqueciMinhaSenhaModalComponent implements OnInit {

  formLogin: FormGroup;
  spinnerUsuario: boolean;
  clientesSiga: any[];
  selecionarCliente: boolean;

  carregando = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EsqueciMinhaSenhaModalComponent>, private formBuilder: FormBuilder,
    private toaster: ToastService, private sigaService: SigaService) { }

  ngOnInit() {

    this.formLogin = this.formBuilder.group({
      login: [null, [Validators.required, Validators.minLength(5)]],
      cdCliente: [null, Validators.required],
    });
  }

  fecharModal(): void {
    this.dialogRef.close(null);
  }

  getDadosUsuario() {
    const login = this.formLogin.get('login').value as string;

    if (login != null && login.length > 4) {
      this.spinnerUsuario = true;
      this.clientesSiga = [];

      this.sigaService.getDadosLogin(login.toLocaleLowerCase())
        .pipe(
          finalize(() => {
            this.spinnerUsuario = false;
          })
        )
        .subscribe((clientes: ClienteSiga[]) => {
          this.clientesSiga = clientes;
          if (clientes.length > 1) {
            this.selecionarCliente = true;
          } else {
            this.selecionarCliente = false;
            this.formLogin.get('cdCliente').setValue(clientes[0].cdCliente);
          }
        }, (error) => {
          this.formLogin.get('login').setErrors({ notValid: true })
          this.toaster.show({
            type: 'warning',
            text: error.error.detail != undefined ? error.error.detail : 'Erro ao tentar se conectar ao SIGA.'
          })
        })
    }
  }

  enviarEmailRedefinirSenha() {
    this.carregando = true;
    const cdCliente = this.formLogin.get('cdCliente').value as number;
    const cliente = this.clientesSiga.find(cliente => cliente.cdCliente == cdCliente);
    console.log(cliente);

    const redefinirSenha: EsqueciMinhaSenha = {
      cdCliente: cdCliente,
      cdContato: cliente.cdContato,
      nmContato: cliente.nmContato
    }

    this.sigaService.redefinirSenhaSiga(redefinirSenha).pipe(
      finalize(() => this.carregando = false)
    ).subscribe(() => {
      this.toaster.show({ type: 'success', text: 'Foi enviado um e-mail com o link para redefinição de senha.' });
      this.fecharModal();
    }, () => {
      this.toaster.show({ type: 'warning', text: 'Ocorreu um erro interno ao enviar o e-mail para redefinição de senha.' });
    }
    );
  }
}
